import React, { createContext, useContext, ReactNode } from 'react';
import { User } from '../models/User';
import { useContactUser, UseContactUserReturn } from '../hooks/useContactUser';

interface ContactContextType {
  contactUser: UseContactUserReturn | null;
}

const ContactContext = createContext<ContactContextType | undefined>(undefined);

interface ContactProviderProps {
  children: ReactNode;
  user: User | null;
}

export const ContactProvider: React.FC<ContactProviderProps> = ({ children, user }) => {
  const contactUser = user ? useContactUser(user) : null;

  return (
    <ContactContext.Provider value={{ contactUser }}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContactContext = (): ContactContextType => {
  const context = useContext(ContactContext);
  if (context === undefined) {
    throw new Error('useContactContext must be used within a ContactProvider');
  }
  return context;
}; 